var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21C1 23.6264 1.51732 26.2272 2.52241 28.6537C3.5275 31.0802 5.00069 33.285 6.85786 35.1421C8.71504 36.9993 10.9198 38.4725 13.3463 39.4776C15.7728 40.4827 18.3736 41 21 41C23.6264 41 26.2272 40.4827 28.6537 39.4776C31.0802 38.4725 33.285 36.9993 35.1421 35.1421C36.9993 33.285 38.4725 31.0802 39.4776 28.6537C40.4827 26.2272 41 23.6264 41 21C41 18.3736 40.4827 15.7728 39.4776 13.3463C38.4725 10.9198 36.9993 8.71504 35.1421 6.85786C33.285 5.00069 31.0802 3.5275 28.6537 2.52241C26.2272 1.51732 23.6264 1 21 1C18.3736 1 15.7728 1.51732 13.3463 2.52241C10.9198 3.5275 8.71504 5.00069 6.85786 6.85786C5.00069 8.71504 3.5275 10.9198 2.52241 13.3463C1.51732 15.7728 1 18.3736 1 21Z",
    fill: "#16C270",
    stroke: "#16C270",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.915 22.2448L18.915 27.6615L28.915 16.8281",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0bf1b498ec1c41b03a86c4b654986f3a.svg";
export { ForwardRef as ReactComponent };